export default class Fai {
  constructor() {
    this.entity = true;
  }

  loadData(payload) {
    if (payload.Exchange_Member_Info) {
      this.entity = payload.Exchange_Member_Info.Entity_Name;
    }
  }
}
